import React from 'react';
import Loadable from 'react-loadable';

const Loading = props => {
  if (props.error) {
    return (
      <div className="text-danger">
        Loading failure. Please try to reload the page.
      </div>
    );
  } else if (props.pastDelay || props.timedOut) {
    return <div className="text-muted">Loading...</div>;
  } else {
    return null;
  }
};

const AsyncComponent = loader =>
  Loadable({
    loader,
    loading: Loading
  });

export default AsyncComponent;



// WEBPACK FOOTER //
// ./src/tools/async-component.js